import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { DESKTOP_TOTAL_HEIGHT } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  layout: {
    ...dFlex('initial', 'initial'),
    flexDirection: 'column',
    position: 'relative',
    minHeight: '100vh',
  },
  container: {
    flex: 1,
    position: 'relative',
    height: '100%',
    minHeight: `calc(100vh - ${DESKTOP_TOTAL_HEIGHT}px)`,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 274px)',
  },
}));

export default useStyles;
